/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      cloudfront_dist
      lifestoryid
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cloudfront_dist
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLifeStory = /* GraphQL */ `
  query GetLifeStory($id: ID!) {
    getLifeStory(id: $id) {
      id
      personName
      chapters {
        snippets {
          ID
          snippet_title
        }
        title
        __typename
      }
      domain
      createdAt
      updatedAt
      idMap
      indexID
      __typename
    }
  }
`;
export const listLifeStories = /* GraphQL */ `
  query ListLifeStories(
    $filter: ModelLifeStoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLifeStories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        personName
        domain
        createdAt
        updatedAt
        idMap
        __typename
      }
      nextToken
      __typename
    }
  }
`;
